export enum LogistikFirstLevelPage {
  AUTH = 'authentication',
  PRIVACY = 'privacy',
  IMPRESS = 'impress',
  ORDER = 'order',
  CUSTOMER = 'customer',
  ADMIN = 'admin',
  DASHBOARD = 'dashboard',
  RESTRICTED_LANDING = 'external',
}

export enum LogistikSecondLevelPage {
  LOGIN = 'login',
  LEARNING_MATERIALS = 'learning-materials',
  PRODUCT_SETS = 'product-sets',
  ADVERTISING_MATERIALS = 'advertising-materials',
  WORK_MATERIALS = 'work-material',
  TICKETS = 'tickets',
  FURNISHING = 'furnishing',
  INDIVIDUAL = 'individual',
  ENTIRE_TRIP = 'entire-trip',
  WORKSHOP_PACKS = 'workshop-packs',
  OTHER_ORDER = 'other-order',
  TERMINAL = 'terminal',
  INVENTORY = 'inventory',
  PRODUCTS = 'products',
  CART = 'cart',
  CHECKOUT = 'checkout',
  SUCCESS = 'success',
  STATUS = 'status',
  EVALUATION = 'evaluation',
  CONFIGURATION = 'configuration',
  ACCESS = 'access',
  ITEM = 'item',
  CHANCEN_BRIEF = 'FLYA',
  TRAVEL_CERTIFICATE = 'travel-certificates',
  ORDERINGS = 'orderings',
}

export enum LogistikProductCategoryForUrl {
  LEARNING_MATERIAL = 'learning-material',
  ADVERTISING_MATERIAL = 'advertising-material',
  WORK_MATERIAL = 'work-material',
  TICKETS = 'tickets',
  FURNISHING = 'furnishing',
  WORKSHOP_PACK = 'workshop-packs',
  CHANCEN_BRIEF = 'letters',
  INDIVIDUAL = 'individual',
  TRAVEL_CERTIFICATE = 'travel-certificates',
  SET = 'set',
  ENTIRE_TRIP = 'entire-trip',
  OTHER = 'other',
}

export class LogistikRoutes {
  static landing = `/`;
  // static allLessons = `/${CampusFirstLevelPage.CHANCENCAMPUS}/${CampusSecondLevelPage.STUDENT}/${CampusThirdLevelPage.ALL_LESSONS}`;
  static privacy = `/${LogistikFirstLevelPage.PRIVACY}`;
  static impress = `/${LogistikFirstLevelPage.IMPRESS}`;
  static login = `/${LogistikFirstLevelPage.AUTH}/${LogistikSecondLevelPage.LOGIN}`;

  // Base
  static dashboard = `/${LogistikFirstLevelPage.DASHBOARD}`;

  // Order
  static cart = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.CART}`;
  static checkout = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.CHECKOUT}`;
  static orderSuccess = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.SUCCESS}`;
  static orderStatus = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.STATUS}`;
  static productItem = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.ITEM}`;
  static learningMaterials = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.LEARNING_MATERIALS}`;
  static logistikProductSets = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.PRODUCT_SETS}`;
  static advertisingMaterials = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.ADVERTISING_MATERIALS}`;
  static workMaterials = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.WORK_MATERIALS}`;
  static tickets = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.TICKETS}`;
  static furnishingMaterials = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.FURNISHING}`;
  static chancenBrief = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.CHANCEN_BRIEF}`;
  static individualOrder = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.INDIVIDUAL}`;
  static entireTrip = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.ENTIRE_TRIP}`;
  static otherOrder = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.OTHER_ORDER}`;
  static workshopPacks = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.WORKSHOP_PACKS}`;
  static travelCertificate = `/${LogistikFirstLevelPage.ORDER}/${LogistikSecondLevelPage.TRAVEL_CERTIFICATE}`;

  // Admin
  static terminal = `/${LogistikFirstLevelPage.ADMIN}/${LogistikSecondLevelPage.TERMINAL}`;
  static inventory = `/${LogistikFirstLevelPage.ADMIN}/${LogistikSecondLevelPage.INVENTORY}`;
  static products = `/${LogistikFirstLevelPage.ADMIN}/${LogistikSecondLevelPage.PRODUCTS}`;
  static evaluation = `/${LogistikFirstLevelPage.ADMIN}/${LogistikSecondLevelPage.EVALUATION}`;
  static configuration = `/${LogistikFirstLevelPage.ADMIN}/${LogistikSecondLevelPage.CONFIGURATION}`;
  static access = `/${LogistikFirstLevelPage.ADMIN}/${LogistikSecondLevelPage.ACCESS}`;
  static orderings = `/${LogistikFirstLevelPage.ADMIN}/${LogistikSecondLevelPage.ORDERINGS}`;
}
